import request from '@/utils/request';

// 获取流程引擎列表
export function FlowEngineList(data) {
  return request({
    url: "/api/workflow/Engine/FlowEngine",
    method: 'get',
    data: data
  });
}
// 获取流程引擎信息
export function FlowEngineInfo(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id),
    method: 'get'
  });
}
// 删除流程引擎
export function Delete(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id),
    method: 'DELETE'
  });
}
// 新建流程引擎
export function Create(data) {
  return request({
    url: "/api/workflow/Engine/FlowEngine",
    method: 'post',
    data: data
  });
}
//  更新流程引擎
export function Update(data) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
// 复制流程表单
export function Copy(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id, "/Actions/Copy"),
    method: 'post'
  });
}
// 导出流程表单
export function exportData(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id, "/Actions/ExportData"),
    method: 'GET'
  });
}
// 发布流程引擎
export function Release(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/Release/".concat(id),
    method: 'post'
  });
}
// 停止流程引擎
export function Stop(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/Stop/".concat(id),
    method: 'post'
  });
}
// 列表ListAll
export function FlowEngineListAll() {
  return request({
    url: "/api/workflow/Engine/FlowEngine/ListAll",
    method: 'get'
  });
}
// 流程引擎下拉框
export function FlowEngineSelector(type) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/Selector",
    method: 'get',
    data: {
      type: type
    }
  });
}
// 流程表单主表属性
export function getFormDataFields(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id, "/FormDataFields"),
    method: 'get'
  });
}
// 流程表单数据
export function FieldDataSelect(id) {
  return request({
    url: "/api/workflow/Engine/FlowEngine/".concat(id, "/FieldDataSelect"),
    method: 'get'
  });
}
// 获取流程表单详情
export function getFlowTaskData(flowId, id) {
  return request({
    url: "/api/workflow/Engine/FlowTask/".concat(flowId, "/").concat(id),
    method: 'get'
  });
}